<ion-header [translucent]="true">
  <ion-toolbar>
    <ion-buttons slot="start">
      @if (isModalView) {
        <ion-button (click)="goBack()">
          <ion-icon
            slot="icon-only"
            name="chevron-back"
          ></ion-icon>
        </ion-button>
      }
      @if (!isModalView) {
        <ion-button
          [opacity]="1"
          [rotaDisable]="true"
        >
          <ion-icon
            slot="icon-only"
            name="people-outline"
          ></ion-icon>
        </ion-button>
      }
    </ion-buttons>
    <ion-title>{{ 'Presence_Monitoring' | translate }}</ion-title>
    @if (isLoading()) {
      <ion-progress-bar type="indeterminate"></ion-progress-bar>
    }
  </ion-toolbar>

  <ion-toolbar>
    @if (isDesktopView && prevSlideExist) {
      <ion-buttons slot="start">
        <ion-button (click)="prevSlide()">
          <ion-icon
            slot="icon-only"
            name="arrow-back"
          ></ion-icon>
        </ion-button>
      </ion-buttons>
    }
    <ion-title slot="start">{{ headerTitle() }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="toggleMonitoringMode()">
        <ion-icon
          slot="icon-only"
          [name]="isMonitoringMode ? 'eye' : 'eye-off-outline'"
        ></ion-icon>
      </ion-button>

      <ion-button (click)="toggleFilter()">
        <ion-icon
          slot="icon-only"
          [name]="isFilterOpen || isFilterActive ? 'funnel' : 'funnel-outline'"
        ></ion-icon>
      </ion-button>

      @if (isDesktopView && nextSlideExist) {
        <ion-button (click)="nextSlide()">
          <ion-icon
            slot="icon-only"
            name="arrow-forward"
          ></ion-icon>
        </ion-button>
      }
    </ion-buttons>
  </ion-toolbar>

  <ion-toolbar>
    <ion-searchbar
      slot="start"
      [animated]="true"
      [placeholder]="'Search_employees' | translate"
      (ionInput)="handleSearch($event)"
    ></ion-searchbar>
  </ion-toolbar>
</ion-header>

<ion-content [fullscreen]="true">
  <div class="swapper-wrapper">
    <swiper-container
      #swiper
      [pagination]="true"
      (swiperafterinit)="swiperReady($event)"
      (swiperactiveindexchange)="onChangeSlide()"
    >
      <swiper-slide>
        <rota-monitoring-list
          (refreshing)="isLoading.set($event)"
          [page]="1"
          #listForPage1
        />
      </swiper-slide>
      <swiper-slide>
        <rota-monitoring-list
          (refreshing)="isLoading.set($event)"
          [page]="2"
          #listForPage2
        />
      </swiper-slide>
      <swiper-slide>
        <rota-monitoring-list
          (refreshing)="isLoading.set($event)"
          [page]="3"
          #listForPage3
        />
      </swiper-slide>
      <swiper-slide>
        <rota-monitoring-list
          (refreshing)="isLoading.set($event)"
          [page]="4"
          #listForPage4
        />
      </swiper-slide>
    </swiper-container>
  </div>
</ion-content>
